import { CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useState, useRef, useEffect } from "react";

export default function ConfirmDialog({
  text,
  handleClose: onClose,
  open,
  successTimeout,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const timerRef = useRef(null);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleSuccess = () => {
    setIsLoading(true);

    if (successTimeout) {
      timerRef.current = setTimeout(() => {
        // Prima resetta lo stato locale
        if (isMounted.current) setIsLoading(false);

        // Poi chiama il callback che probabilmente smonta il componente
        onClose(true);
      }, successTimeout);
    } else {
      setIsLoading(false);
      onClose(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      onClose(event);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} disableEscapeKeyDown>
      <DialogTitle>{text.text}</DialogTitle>
      <DialogContent style={{ backgroundColor: "#383838" }}>
        <DialogContentText>{text.description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={() => handleClose(false)}
          color="secondary"
        >
          Annulla
        </Button>
        <Button onClick={handleSuccess} color="primary" autoFocus>
          {isLoading ? <CircularProgress size={24} /> : "Conferma"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
